import React from "react";
import {
  Col,
  Row,
  Button,
  Form,
  FormGroup,
  Label,
  Input,
  FormFeedback,
  Spinner,
} from "reactstrap";
import { useFormik } from "formik";
import * as Yup from "yup";

const EstablishmentForm = ({ establishment, isCreating, onSubmit, onCancel, isSaving }: any) => {
  const validation = useFormik({
    enableReinitialize: true,
    initialValues: {
      code: establishment?.code || "",
      address: establishment?.address || "",
    },
    validationSchema: Yup.object({
      code: Yup.string().required("El código es requerido"), 
      address: Yup.string().required("La dirección es requerida"),
    }),
    onSubmit: (values) => {
      onSubmit(values);
    },
  });

  return (
    <Form onSubmit={(e) => { e.preventDefault(); validation.handleSubmit(); }} className="p-3 border rounded bg-light mb-3">
      <div className="d-flex align-items-center mb-3">
          <h6 className="flex-grow-1 mb-0 fw-bold">{isCreating ? "Nuevo Establecimiento" : "Editar Establecimiento"}</h6>
      </div>
      <Row>
        <Col md={4}>
          <FormGroup>
            <Label className="small">Código</Label>
            <Input bsSize="sm" name="code" placeholder="001" value={validation.values.code} onChange={validation.handleChange} onBlur={validation.handleBlur} invalid={!!validation.touched.code && !!validation.errors.code} />
            {validation.touched.code && validation.errors.code ? <FormFeedback>{validation.errors.code as string}</FormFeedback> : null}
          </FormGroup>
        </Col>
        <Col md={8}>
          <FormGroup>
            <Label className="small">Dirección</Label>
            <Input bsSize="sm" name="address" placeholder="Dirección" value={validation.values.address} onChange={validation.handleChange} onBlur={validation.handleBlur} invalid={!!validation.touched.address && !!validation.errors.address} />
            {validation.touched.address && validation.errors.address ? <FormFeedback>{validation.errors.address as string}</FormFeedback> : null}
          </FormGroup>
        </Col>
      </Row>
      <div className="d-flex justify-content-end gap-2 mt-2">
        <Button color="light" onClick={onCancel} size="sm" disabled={isSaving}>Cancelar</Button>
        <Button
          color="primary"
          size="sm"
          className="waves-effect waves-light"
          type="submit"
          disabled={isSaving}
        >
          {isSaving ? (
            <>
              <Spinner size="sm" className="me-2" />
              Guardando...
            </>
          ) : (
            <>
              <i className="ri-save-line label-icon align-middle fs-16 me-2"></i>
              Guardar
            </>
          )}
        </Button>
      </div>
    </Form>
  );
};

export default EstablishmentForm;
